/**
 * Button Permission Mapping
 * Maps page types to their required permissions for different actions
 */

export const BUTTON_PERMISSION_MAP = {
  // User Management
  'users': {
    add: 'User Management',
    edit: 'User Management', 
    delete: 'User Management'
  },
  'customers': {
    add: 'Customer Management',
    edit: 'Customer Management',
    delete: 'Customer Management'
  },
  'business-users': {
    add: 'Business User Management',
    edit: 'Business User Management',
    delete: 'Business User Management'
  },

  // Product Management
  'product-category': {
    add: 'Product Category',
    edit: 'Product Category',
    delete: 'Product Category'
  },
  'product-packaging': {
    add: 'Product Packaging',
    edit: 'Product Packaging',
    delete: 'Product Packaging'
  },

  // Order Management
  'order-service': {
    add: 'Order Service',
    edit: 'Order Service',
    delete: 'Order Service'
  },
  'order-status': {
    add: 'Order Status',
    edit: 'Order Status',
    delete: 'Order Status'
  },
  'cashout-request': {
    add: 'Cashout Request',
    edit: 'Cashout Request',
    delete: 'Cashout Request'
  },

  // Inventory Management
  'inventory-package': {
    add: 'Inventory Package',
    edit: 'Inventory Package',
    delete: 'Inventory Package'
  },
  'inventory-package-request': {
    add: 'Inventory Package Request',
    edit: 'Inventory Package Request',
    delete: 'Inventory Package Request'
  },
  'product-inventory-request': {
    add: 'Product Inventory Request',
    edit: 'Product Inventory Request',
    delete: 'Product Inventory Request'
  },

  // System Management
  'coupons': {
    add: 'Coupons',
    edit: 'Coupons',
    delete: 'Coupons'
  },
  'referral-code': {
    add: 'Referral Code',
    edit: 'Referral Code',
    delete: 'Referral Code'
  },
  'city-management': {
    add: 'City Management Access',
    edit: 'City Management Access',
    delete: 'City Management Access'
  },
  'zone': {
    add: 'Zone Management',
    edit: 'Zone Management',
    delete: 'Zone Management'
  },
  'hq-address': {
    add: 'HQ Address Access',
    edit: 'HQ Address Access',
    delete: 'HQ Address Access'
  },

  // Package Management
  'package-dimension': {
    add: 'Package Dimension',
    edit: 'Package Dimension',
    delete: 'Package Dimension'
  },
  'package-weight': {
    add: 'Package Weight',
    edit: 'Package Weight',
    delete: 'Package Weight'
  },
  'package-opened-charges': {
    add: 'Package Opened Charges',
    edit: 'Package Opened Charges',
    delete: 'Package Opened Charges'
  },

  // Issue Management
  'log-issues': {
    add: 'Log Issues',
    edit: 'Log Issues',
    delete: 'Log Issues'
  },
  'main-reasons': {
    add: 'Main Reasons',
    edit: 'Main Reasons',
    delete: 'Main Reasons'
  },
  'commission-amount': {
    add: 'Commission Amount',
    edit: 'Commission Amount',
    delete: 'Commission Amount'
  },

  // Billing
  'billing-invoice-payment': {
    add: 'Billing Invoice Payment',
    edit: 'Billing Invoice Payment',
    delete: 'Billing Invoice Payment'
  },

  // Role Management
  'sub-admin': {
    add: 'Sub Admin',
    edit: 'Sub Admin',
    delete: 'Sub Admin'
  },
  'roles': {
    add: 'Roles',
    edit: 'Roles',
    delete: 'Roles'
  },
  'permissions': {
    add: 'Permissions',
    edit: 'Permissions',
    delete: 'Permissions'
  },

  // Website Content
  'privacy-policy': {
    add: 'Privacy Policy',
    edit: 'Privacy Policy',
    delete: 'Privacy Policy'
  },
  'terms-conditions': {
    add: 'Terms Conditions',
    edit: 'Terms Conditions',
    delete: 'Terms Conditions'
  },
  'testimonials': {
    add: 'Testimonials',
    edit: 'Testimonials',
    delete: 'Testimonials'
  },
  'contact-us': {
    add: 'Contact Us',
    edit: 'Contact Us',
    delete: 'Contact Us'
  },
  'faqs': {
    add: 'FAQs',
    edit: 'FAQs',
    delete: 'FAQs'
  },
  'blog': {
    add: 'Blog',
    edit: 'Blog',
    delete: 'Blog'
  },
  'our-team': {
    add: 'Our Team',
    edit: 'Our Team',
    delete: 'Our Team'
  }
};

/**
 * Get permission name for a specific page and action
 * @param {string} pageType - The page type (e.g., 'users', 'customers')
 * @param {string} action - The action (add, edit, delete)
 * @returns {string|null} - Permission name or null if not found
 */
export const getButtonPermission = (pageType, action) => {
  const pagePermissions = BUTTON_PERMISSION_MAP[pageType];
  return pagePermissions ? pagePermissions[action] : null;
};

/**
 * Get all permissions for a page
 * @param {string} pageType - The page type
 * @returns {Object|null} - Object with add, edit, delete permissions or null
 */
export const getPagePermissions = (pageType) => {
  return BUTTON_PERMISSION_MAP[pageType] || null;
};
